import { render, staticRenderFns } from "./DynamicListTemplateDetailPage.vue?vue&type=template&id=a6e288ec&scoped=true"
import script from "./DynamicListTemplateDetailPage.vue?vue&type=script&lang=ts"
export * from "./DynamicListTemplateDetailPage.vue?vue&type=script&lang=ts"
import style0 from "./DynamicListTemplateDetailPage.vue?vue&type=style&index=0&id=a6e288ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e288ec",
  null
  
)

export default component.exports